module.exports = __webpack_public_path__ + "static/media/ic-social.a4e7c86a.webp";